import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule} from '@angular/common';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {provideTranslateService, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader} from '@ngx-translate/http-loader';
import {MessageService} from 'primeng/api';
import {CookieService} from 'ngx-cookie-service';
import {NgxGlobalContactFooterModule} from 'ngx-global-contact-footer';
import {NOC_ANALYTICS} from 'ngx-shared-services';
import {analytics} from 'noc-analytics';
import {MqttModule, MqttService} from 'ngx-mqtt';

import {AppComponent} from './app.component';
import {routes} from './app.routes';
import {authInterceptor} from './interceptors';

export function windowFactory(): any {
    return window;
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        RouterModule.forRoot(routes),
        TranslateModule.forRoot(),
        MqttModule.forRoot({connectOnCreate: false}),
        NgxGlobalContactFooterModule.forRoot({ namespace: 'ngx-global-contact-footer.' })
    ],
    providers: [
        { provide: NOC_ANALYTICS, useValue: analytics },
        provideHttpClient(withInterceptors([authInterceptor])),
        MessageService,
        CookieService,
        MqttService,
        { provide: 'WINDOW', useFactory: windowFactory },
        provideTranslateService({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
        }),
        { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: '/assets/i18n/', suffix: '.json' } }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],  // Add this line
    bootstrap: [AppComponent]
})
export class AppModule { }